
<div>
  <PageHeader></PageHeader>

  <div class="container">
    <!-- Boards -->
    <div>
      <div class="item-title mt-3 text-center">Switch user</div>

      <div class="text-center">You are signed in as <strong>{{ masterUser.username }}</strong>. This is no personal user. <br><strong>Please open your browser as your personal user.</strong></div>

      <div class="text-center mt-5 mb-5">
        <button class="badgebutton active" @click="navigateToBoards()">Ignore and use {{masterUser.username}}</button>
      </div>

      <div class="text-center">
        <p class="font-weight-bold">How to sign in with another user</p>
        <img src="/howtootheruser.gif" style="margin-top: 20px;" alt="How to">
      </div>
    </div>

    <AppInfo />
  </div>
</div>
